import { useEffect } from "react";
import { z } from "zod";
import { localStore } from "../../../lib/store";

const roomVisitsStore = localStore<Record<string, number>>(
  "roomVisits",
  {},
  z.record(z.string(), z.number())
);

export function recordRoomVisit(roomId: string): void {
  roomVisitsStore.set((prev) => ({ ...prev, [roomId]: Date.now() }));
}

export function getLastRoomVisit(roomId: string): number | null {
  const lastVisit = roomVisitsStore.get()[roomId];
  return lastVisit === undefined ? null : lastVisit;
}

export function roomHasNewContent(
  lastContentAddedAt: string | null,
  roomId: string
): boolean {
  if (lastContentAddedAt === null) return false;
  const lastVisit = getLastRoomVisit(roomId);
  if (lastVisit === null) return false; // new device → already seen
  return new Date(lastContentAddedAt).getTime() > lastVisit;
}

/**
 * Records a visit to the room whose feed is on screen, whether it was opened
 * by a tap or straight from a link. `null` is no room.
 */
export function useRecordRoomVisit(roomId: string | null): void {
  useEffect(() => {
    if (roomId === null) return;
    recordRoomVisit(roomId);
  }, [roomId]);
}
